import React, { useState } from 'react';
import { statusMaper } from "../../tools";

// import useStyles from './useStyles';

import { IconButton, Tooltip } from '@mui/material'
import ModalChangeStatus from '../ModalChangeStatus'

import ExitToAppIcon from '@mui/icons-material/ExitToApp';






function StatusManager(props) {
  const {
    docId,
    documentName,
    currentStatus,
    awailableStatuses,
    statusDirectory = [],
  } = props;


  const [dialogVisible, setDialogVisible] = useState(false)

  if (!Array.isArray(statusDirectory) || statusDirectory.length === 0) return null;

  return (
    <>
        <ModalChangeStatus
          onClose={()=>setDialogVisible(false)}
          open={dialogVisible}
          docId={docId}
          documentName={documentName}
          selectOptions={statusMaper(awailableStatuses, statusDirectory)}
        />
      <span>{statusMaper(currentStatus, statusDirectory).label}</span>
      <Tooltip title="Сменить статус">
        <IconButton color='success' disabled={!awailableStatuses?.length} onClick={()=>setDialogVisible(true)}>
          <ExitToAppIcon />
        </IconButton>
      </Tooltip>
    </>
  )

}



export default StatusManager;
